import React from 'react';
import './AccountSettings.css';

function AccountSettings({ user, onLogout }) {
  return (
    <div className="account-settings">
      <h2>Account Settings</h2>
      
      <section className="account-section">
        <h3>Account Information</h3>
        <div className="account-info">
          <div className="info-item">
            <label>Email:</label>
            <span>{user.email}</span>
          </div>
          <div className="info-item">
            <label>Username:</label>
            <span>{user.username || 'Not set'}</span>
          </div>
          <div className="info-item">
            <label>Member since:</label>
            <span>{user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'Recently'}</span>
          </div>
        </div>
      </section>

      <section className="account-section">
        <h3>Actions</h3>
        <button
          onClick={onLogout}
          className="btn-logout"
        >
          Logout
        </button>
      </section>
    </div>
  );
}

export default AccountSettings;

